import React from 'react';

import {Card, CircularProgress, Stack} from "@mui/joy";

// components
import BaseApi from "../../utils/BaseApi";
import Avatar from "@mui/joy/Avatar";
import Typography from "@mui/joy/Typography";
import StickerPack from "./StickerPack";



class RoomStickers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            stickerPacks: null,
            stickerPack: null,
        }
    }

    async componentDidMount() {
        await this.retrievePacks()
    }

    async componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.roomSubscriber.id !== this.props.roomSubscriber.id) {
            await this.retrievePacks()
        }
    }

    async retrievePacks(){
        const url = `sticker_pack/`;
        const api = new BaseApi();
        let params = {
            page_size: 10000,
        };
        let response = await api.get(
            url,
            params
        );
        this.setState({
            stickerPacks: response.data.results
        })
    }

    unsetPack(){
        this.setState({
            stickerPack: null
        })
    }

    render() {
        if (!this.state.stickerPacks) {
            return (
                <CircularProgress/>
            )
        }
        if (this.state.stickerPack){
            return (
                <StickerPack
                    pack={this.state.stickerPack}
                    unsetCallBack={this.unsetPack.bind(this)}
                    addStickerCallback={this.props.addStickerCallback}
                />
            )
        }
        return(
            <Stack
                spacing={1}
                sx={{
                    width: '295px'
                }}
            >
                {
                    this.state.stickerPacks.map(s => (
                        <Card
                            onClick={() => {
                                this.setState({
                                    stickerPack: s
                                })
                            }}
                        >
                            <Stack
                                direction={'row'}
                                spacing={1}
                            >
                                <Avatar
                                    color={'primary'}
                                >
                                    <img
                                        src={`data:image/png};base64,${s.avatar}`}
                                    />
                                </Avatar>
                                <Typography>
                                    {s.title}
                                </Typography>
                            </Stack>
                        </Card>
                    ))
                }
            </Stack>
        )
    }
}

export default RoomStickers
